module.exports = __webpack_public_path__ + "media/assets/images/mice-logo-frog-1d0f2618036b55466c96842da6fbe531.png";